import { apiClient } from './api';
import {
  clearStoredActiveTenantId,
  setStoredActiveTenantId,
} from './tenantStorage';
import type { TenantBootstrapResponse, TenantSelectPayload } from '../types';

function syncStoredTenantId(bootstrap: TenantBootstrapResponse): TenantBootstrapResponse {
  const tenantId = bootstrap.activeTenant?.tenant?.id ?? null;
  if (tenantId == null) {
    clearStoredActiveTenantId();
  } else {
    setStoredActiveTenantId(tenantId);
  }
  return bootstrap;
}

export async function getTenantBootstrap(): Promise<TenantBootstrapResponse> {
  const response = await apiClient.get<TenantBootstrapResponse>('/api/v1/web/bootstrap/me');
  return syncStoredTenantId(response.data);
}

export async function selectTenant(payload: TenantSelectPayload): Promise<TenantBootstrapResponse> {
  const response = await apiClient.post<TenantBootstrapResponse>('/api/v1/web/tenant/select', payload);
  return syncStoredTenantId(response.data);
}
